import { createContext, useEffect, useMemo } from 'react';
import { createUseDefinedContext } from './createUseDefinedContext';
import { createPropsContextProvider } from '../createPropsContextProvider';
import { createPubSub } from '../pubSub';
/**
 * A hook that returns instance of a PubSub mechanism to enable two-way
 * communication between parent and nested components.
 * @returns instance of new PubSub
 */
export const usePubSub = () => useMemo(createPubSub, []);
const context = createContext(undefined);
export const PubSubProvider = createPropsContextProvider(context);
export const usePubSubContext = createUseDefinedContext(context, 'PubSub context not found. You should provide PubSub to the context');
/**
 * A hook that activates the subscription for the time the component is mounted
 * @param topic a PubSub topic to subscribe to
 * @param handler a handler of the subscription
 */
export const usePubSubSubscribe = (topic, handler) => {
    const { pubSub } = usePubSubContext();
    // @ts-ignore
    useEffect(() => {
        if (handler) {
            const unsubscribe = pubSub.subscribe(topic, handler);
            return () => {
                unsubscribe();
            };
        }
    }, [pubSub, handler, topic]);
};
//# sourceMappingURL=usePubSub.js.map